import ReportsProvider from "providers/ReportsProvider";
import ExtractReportsTemplate from "components/templates/ExtractReportsTemplate";

const ExtractReports = () => {

  return (
   <ReportsProvider>
    <ExtractReportsTemplate/>
   </ReportsProvider>
  )
}

export default ExtractReports